export {
    Context as WireTemplatesContext,
    Provider as WireTemplatesContextProvider,
    Consumer as WireTemplatesConsumer
} from './WireTemplatesContext'